import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

const STEP_ICONS = [
  // Register
  <svg key="1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="m16 11 2 2 4-4" />
  </svg>,
  // Share
  <svg key="2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 2 11 13" /><path d="M22 2 15 22l-4-9-9-4 20-7z" />
  </svg>,
  // Experience
  <svg key="3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2 15 9l7 .5-5.3 4.6L18.4 21 12 17l-6.4 4 1.7-6.9L2 9.5 9 9z" />
  </svg>,
];

export default function LpHowItWorks() {
  const headRef = useRevealOnScroll<HTMLDivElement>();
  const step1Ref = useRevealOnScroll<HTMLElement>();
  const step2Ref = useRevealOnScroll<HTMLElement>();
  const step3Ref = useRevealOnScroll<HTMLElement>();
  const refs = [step1Ref, step2Ref, step3Ref];

  const steps = [
    { numKey: 'landingPage.v2.howItWorks.step1.number', titleKey: 'landingPage.v2.howItWorks.step1.title', bodyKey: 'landingPage.v2.howItWorks.step1.body', n: '1' },
    { numKey: 'landingPage.v2.howItWorks.step2.number', titleKey: 'landingPage.v2.howItWorks.step2.title', bodyKey: 'landingPage.v2.howItWorks.step2.body', n: '2' },
    { numKey: 'landingPage.v2.howItWorks.step3.number', titleKey: 'landingPage.v2.howItWorks.step3.title', bodyKey: 'landingPage.v2.howItWorks.step3.body', n: '3' },
  ];

  return (
    <section className="section-pad" aria-labelledby="lp-hiw-title">
      <div className="wrap">
        <div ref={headRef} className="sec-head reveal">
          <span className="eyebrow"><span className="dot" />{t('landingPage.v2.howItWorks.label')}</span>
          <h2 className="display" id="lp-hiw-title">{t('landingPage.v2.howItWorks.title')}</h2>
          <p className="lead">{t('landingPage.v2.howItWorks.subtitle')}</p>
        </div>
        <div className="steps">
          {steps.map((step, i) => (
            <article key={i} ref={refs[i]} className="step reveal">
              <div className="step__num">{t(step.numKey)}</div>
              <div className="step__ico">{STEP_ICONS[i]}</div>
              <h3>{t(step.titleKey)}</h3>
              <p>{t(step.bodyKey)}</p>
              <span className="step__big">{step.n}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
